<template>
    <div style="overflow: hidden;width: 100%">
        <CommonHeader />
        <div class="i-my-info">
            <img class="index-bg" src="../../img/bg.png">
            <div class="container">
                <a-row>
                    <a-col class="mt-6" :span="24">
                        <IndexMenu />
                    </a-col>
                </a-row>
                <a-row class="mt-6 main-nav" type="flex" justify="space-between">
                    <a-col :span="8">
                        <a @click="toIndex()">
                            <div>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-project-a"></use>
                                </svg>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-project"></use>
                                </svg>
                            </div>
                            <div>
                                <b class="size6">我的项目</b>
                            </div>

                        </a>
                    </a-col>
                    <a-col :span="8">
                        <a @click="toAnnounceIndex">
                            <div>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-notice-a"></use>
                                </svg>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-notice"></use>
                                </svg>
                            </div>
                            <div>
                                <b class="size6">项目公告</b>
                            </div>

                        </a>
                    </a-col>
                    <a-col :span="8">
                        <a class="active">
                            <div>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-my-a"></use>
                                </svg>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-my"></use>
                                </svg>
                            </div>
                            <div>
                                <b class="size6">账号管理</b>
                            </div>
                        </a>
                    </a-col>
                </a-row>
            </div>
        </div>
        <div class="container" style="min-height: calc(100vh - 56px - 225px - 88px);">
            <a-row class="mt-6">
                <!--          *************************************************************   用户基本信息   ******************************************************   -->
                <a-col :span="24">
                    <a-card :loading="loading">
                        <a-row>
                            <a-col :span="18">
                                <h2>账号基本信息</h2>
                                <table class="my-info">
                                    <tr>
                                        <th>姓名：</th>
                                        <td>{{account.nickname}}</td>
                                        <th>证件号码：</th>
                                        <td>
                                            <span v-if="account.cardId">{{account.cardId.replace(/^(.{6})(?:\d+)(.{4})$/, "$1****$2")}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>手机号：</th>
                                        <td>{{account.phone}}</td>
                                        <th>邮箱：</th>
                                        <td>
                                            <a-input v-if="isEmailEdit === true" v-model="account.email"  @keyup.enter.native="onEmail" style="width: 130px;"></a-input>
                                            <span v-if="isEmailEdit === false">{{account.email}}</span>
                                            <span>&nbsp;&nbsp;&nbsp;</span>
                                            <a-button ghost size="small" type="primary" @click="onEmail">{{emailEdit}}</a-button>
                                        </td>
                                    </tr>
                                </table>
                                <div style="margin-top: 20px;"></div>
                                <a-button class="mt-3" icon="form" type="primary" ghost @click="changePass">修改密码</a-button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <a-button class="mt-3" icon="form" type="primary" ghost @click="changePhone">变更手机号</a-button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <a-button class="mt-3" icon="form" type="primary" ghost @click="payHistory">支付记录</a-button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <a-button class="mt-3" v-if="supplier && supplier.supplierType === '2' " icon="form" type="primary" ghost @click="unBind">解除企业绑定</a-button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <!--  自然人个人开票资料-->
                                <a-button class="mt-3" v-if="supplier &&  supplier.supplierType === '1' && supplier.natureType === '1' " icon="form" type="primary" @click="onSelfPersonBillInfo" ghost >开票资料</a-button>
<!--                                <span>&nbsp;&nbsp;&nbsp;</span>-->
<!--                                <a-button v-if="supplier.supplierType === '2' && !account.supplierId" class="mt-3" icon="form" type="primary"  @click="changeSupplier"  ghost>关联到企业</a-button>-->
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <a-button class="mt-3" icon="form" type="primary" v-if="(supplier && supplier.supplierType === '1' && supplier.natureType === '1' ) ||  !supplier"    @click="onCertificate"   ghost>单位认证</a-button>

                            </a-col>
                            <a-col :span="6">
                                <img src="../../img/my-info.png" style="margin: auto">
                            </a-col>
                        </a-row>
                        <!--密码更改-->
                        <ChangePass :visible="changePassVisible" ref="changePass" @cancel="changePassClose" ></ChangePass>
                        <!--手机号更改-->
                        <ChangePhone :visible="changePhoneVisible" ref="changePhone"  @cancel="changePhoneClose"></ChangePhone>
                        <!--支付记录-->
                        <PayHistory :visible="payHistoryVisible" ref="payHistory" @cancel="payHistoryClose" ></PayHistory>
                        <!--企业绑定-->
                        <UnBind :visible="unBindVisible" ref="unBind" @cancel="unBindClose"></UnBind>
                        <!--纯个人供应商开票资料-->
                        <SelfPersonBillInfo :visible="selfPersonBillInfoVisible" ref="selfPersonBillInfo" @cancel="selfPersonBillInfoClose"></SelfPersonBillInfo>

                    </a-card>
                </a-col>
<!--                <a-col :span="12">-->
<!--                    <div v-if="(supplier.supplierType === '1' && supplier.natureType === '2' ) || supplier.supplierType === '2' " style="height: 24px;width: 10px;background: #96B9D8;margin: auto"></div>-->
<!--                    <div v-else style="height: 24px;width: 10px;"></div>-->
<!--                </a-col>-->
<!--                <a-col :span="12">-->
<!--                    <div v-if="(supplier.supplierType === '1' && supplier.natureType === '2' ) || supplier.supplierType === '2' " style="height: 24px;width: 10px;background: #96B9D8;margin: auto"></div>-->
<!--                    <div v-else style="height: 24px;width: 10px;"></div>-->
<!--                </a-col>-->

                <a-col :span="12">
                    <div v-if="(supplier && supplier.supplierType === '1' && supplier.natureType === '2') || (supplier && supplier.supplierType === '2')" style="height: 24px;width: 10px;background: #96B9D8;margin: auto"></div>
                    <div v-else style="height: 24px;width: 10px;"></div>
                </a-col>
                <a-col :span="12">
                    <div  v-if="(supplier && supplier.supplierType === '1' && supplier.natureType === '2') || (supplier && supplier.supplierType === '2')"  style="height: 24px;width: 10px;background: #96B9D8;margin: auto"></div>
                    <div v-else style="height: 24px;width: 10px;"></div>
                </a-col>

                <!--          *************************************************************   自然人-个体户-单位信息   ******************************************************   -->
                <a-col :span="24">
                    <a-card :loading="loading" v-if="supplier && supplier.supplierType === '1' && supplier.natureType === '2'  ">
                        <a-row>
                            <a-col :span="18">
                                <h2>单位信息</h2>
                                <table class="my-info">
                                    <tr>
                                        <th>单位名称：</th>
                                        <td>{{supplier.supplierName}}</td>

                                        <th>营业执照注册号：</th>
                                        <td> {{supplier.supplierCode}}</td>
                                    </tr>
                                    <tr>
                                        <th>负责人：</th>
                                        <td> {{supplier.legalName}}</td>
                                        <th>手机号：</th>
                                        <td>
                                           {{supplier.contactsPhone}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>经营地址：</th>
                                        <td colspan="3">
                                            {{supplier.completeRegisterAddress}}
                                        </td>
                                    </tr>

                                </table>
                                <div style="margin-top: 20px;"></div>
                                <a-button class="mt-3" icon="form" type="primary"  @click="onNatureUnit"  ghost>查看</a-button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <a-button  v-if="account.supplierId"  class="mt-3" icon="form" type="primary"  @click="onModifyCertificate"  ghost>信息变更</a-button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <a-button class="mt-3" icon="form" type="primary"  @click="selfBillInfo"  ghost>开票资料</a-button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
<!--                                <a-button  class="mt-3" icon="form" type="primary" v-if="!account.supplierId"  @click="onNatureAuth"  ghost>单位认证</a-button>-->
<!--                                <a-button v-if="false" class="mt-3" icon="form" type="primary"  @click="moreData"  ghost>更多资料</a-button>-->


                            </a-col>
                            <a-col :span="6">
                                <img v-if="supplier && supplier.supplierType === '1'" src="../../img/qualification.png" style="margin: auto">
                                <img v-else src="../../img/qualification-no.png" @click="onNatureAuth" style="margin: auto;cursor: pointer;">
                            </a-col>
                        </a-row>
                    </a-card>
<!--           ******************************************************  法人供应商-单位信息   ******************************************************  -->
                    <a-card :loading="loading" v-if="supplier &&  supplier.supplierType === '2'">
                        <a-row>
                            <a-col :span="18">
                                <h2>单位信息</h2>
                                <table class="my-info">
                                    <tr>
                                        <th>单位名称：</th>
                                        <td>{{supplier.supplierName}}</td>
                                        <th>社会统一信用代码：</th>
                                        <td> {{supplier.supplierCode}}</td>
                                    </tr>
                                    <tr>
                                        <th>法定代表人：</th>
                                        <td>
                                            {{supplier.legalName}}
                                        </td>
                                        <th>联系人-手机号码：</th>
                                        <td>
                                            {{supplier.contacts}} &nbsp; {{supplier.contactsPhone}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>注册地址：</th>
                                        <td colspan="3">{{supplier.completeRegisterAddress}}</td>
                                    </tr>
                                </table>
                                <div style="margin-top: 20px;"></div>
                                <a-button class="mt-3" icon="form" type="primary"  @click="onEnterprise"  ghost>查看</a-button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <a-button v-if="account.supplierId" class="mt-3" icon="form" type="primary"  @click="onModifyCertificate"  ghost>信息变更</a-button>
                                <span>&nbsp;</span>
                                <a-button class="mt-3" icon="form" type="primary"  @click="billInfo"  ghost>开票资料</a-button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
<!--                                <a-button class="mt-3" icon="form" type="primary" v-if="!account.supplierId"    @click="onEnterpriseAuth"   ghost>企业认证</a-button>-->
<!--                                <a-button v-if="false" class="mt-3" icon="form" type="primary"  @click="moreData"  ghost>更多资料</a-button>-->
                            </a-col>
                            <a-col :span="6">
                                <img v-if="supplier" src="../../img/qualification.png" style="margin: auto">
                                <img v-else src="../../img/qualification-no.png"  @click="onEnterpriseAuth" style="margin: auto;cursor:pointer;">
                            </a-col>
                        </a-row>
                    </a-card>
                    <!-- 法人供应商单位信息-->
                    <UnitInfo :visible="unitInfoVisible" ref="unitInfo" @cancel="unitInfoClose"></UnitInfo>
                    <!--自然人供应商单位信息-->
                    <UnitNature :visible="unitNatureVisible" ref="unitNature" @cancel="unitNatureClose"></UnitNature>
                    <!--更多资料-->
                    <MoreData :visible="moreDataVisible" ref="moreData" @cancel="moreDataClose"></MoreData>
                    <!--法人开票资料 -->
                    <BillInfo :visible="billInfoVisible" ref="billInfo"  @cancel="billInfoClose"></BillInfo>
                    <!-- 个人体户开票资料-->
                    <SelfBillInfo :visible="selfBillInfoVisible" ref="selfBillInfo" @cancel="selfBillInfoClose"></SelfBillInfo>
                </a-col>


                <a-col :span="12" >
                    <div v-if="supplier && supplier.supplierType === '2'" style="height: 24px;width: 10px;background: #96B9D8;margin: auto"></div>
                    <div v-else style="height: 24px;width: 10px;margin: auto"></div>
                </a-col>
                <a-col :span="12" >
                    <div  v-if="supplier && supplier.supplierType === '2'" style="height: 24px;width: 10px;background: #96B9D8;margin: auto"></div>
                    <div v-else style="height: 24px;width: 10px;margin: auto"></div>
                </a-col>

<!--        ****  ****************************************************法人供应商  子账号管理   **********************************************************   -->
                <a-col :span="24"  v-if="supplier &&  supplier.supplierType === '2' " >
                    <a-card :loading="loading">
                        <h2>
                            子账号管理
                            <a-button class="btn btn-orange" style="float: right" @click="addChild" v-if=" account.accountType === '1' ">
                                新增子账号
                            </a-button>
                        </h2>
                        <div class="personal">
                            <div class="p-col" v-for="it in accountList" >
                                <div class="p-card">
                                    <div class="p-icon" v-if="it.accountType === '2'">
                                        <a-icon type="user"/>
                                    </div>
                                    <div class="p-icon b" v-if="it.accountType === '1'">
                                        <a-icon type="user"/>
                                    </div>
                                    <table class="p-info">
                                        <tr>
                                            <th style="text-align: justify;">姓名：</th>
                                            <td>{{it.nickname}}</td>
                                        </tr>
                                        <tr>
                                            <th>手机号码：</th>
                                            <td>{{it.phone}}</td>
                                        </tr>
                                        <tr>
                                            <th>身份证号：</th>
                                            <td>
                                                <span v-if="it.cardId"> {{ it.cardId.replace(/^(.{6})(?:\d+)(.{4})$/, "$1****$2")}}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <div class="operate"  v-if="it.accountType === '2'">
                                        <a-button class="main" v-if="account.accountType === '1'  " @click="setConfirm(it.id)">设为企业管理员</a-button>
                                        <a-button v-if="account.accountType === '1'">设置项目查看权限</a-button>
                                        <a-button @click="delConfirm(it.id)" v-if=" account.accountType === '1' ">从企业中移除</a-button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </a-card>
                </a-col>
            </a-row>

            <ChildAccount :visible="accountVisible" @success="childOk" @cancel="childClose"></ChildAccount>
            <PersonAccount :visible="personVisible" ref="PersonAccount" @success="personOk"
                           @cancel="personClose"></PersonAccount>
        </div>
        <CommonFooter />
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import ChildAccount from './ChildAccount'
    import PersonAccount from './PersonAccount'
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from '../common/CommonFooter'
    import IndexMenu from '../common/IndexMenu'
    import ChangePhone from './ChangePhone'
    import ChangePass from './ChangePass'
    import PayHistory from  './PayHistory'
    import UnBind from  './UnBind'
    import UnitInfo from './UnitInfo'
    import UnitNature from './UnitNature'
    import BillInfo from  './BillInfo'
    import SelfBillInfo from './SelfBillInfo'
    import SelfPersonBillInfo from './SelfPersonBillInfo'
    import MoreData from  './MoreData'
    import NatureUnitInfo from './NatureUnitInfo'
    import ChangeUnitInfo from './ChangeUnitInfo'

    export default {
        created() {
            this.initData()
        },
        components: {
            ChangeUnitInfo,
            ChildAccount,
            PersonAccount,
            CommonHeader,
            CommonFooter,
            IndexMenu,
            ChangePhone,
            ChangePass,
            PayHistory,
            UnBind,
            UnitInfo,
            UnitNature,
            BillInfo,
            SelfBillInfo,
            SelfPersonBillInfo,
            MoreData,
            NatureUnitInfo,
        },
        data() {
            return {
                loading: false,
                ModalText: '确认是否删除此子账号',
                visible: false,
                confirmLoading: false,
                supplier: '',
                account: '',
                queryParam: {},
                id: this.$route.query.id,
                accountVisible: false,
                personVisible: false,
                enterpriseVisible: false,
                accountList: [],
                emailEdit: '编辑',
                changePhoneVisible: false,
                isEmailEdit: false,
                changePassVisible: false,
                payHistoryVisible: false,
                unBindVisible:false,
                unitEditVisible: false,
                unitInfoVisible: false,
                bankInfoVisible: false,
                billInfoVisible: false,
                unitNatureVisible: false,
                moreDataVisible: false,
                changeUnitInfoVisible: false,
                selfBillInfoVisible: false,
                selfPersonBillInfoVisible: false
            };
        },
        methods: {
            handleClick() {
                this.loading = !this.loading;
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.ModalText = '确认是否删除此子账号';
                this.confirmLoading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.confirmLoading = false;
                }, 2000);
            },
            toIndex() {
                this.$router.push({path: '/Index'})
            },
            handleCancel(e) {
                this.visible = false;
            },
            toAnnounceIndex() {
                this.$router.push({path: '/announce/AnnounceIndex'})
            },
            onSubmit() {
            },
            initData() {
                this.$http.get("/api/v1/supplier/account/supplier_info.json").then(res => {
                    this.account = res.account
                    this.supplier = res.supplier
                    if (res.supplier && res.supplier.extras.accountList) {
                        this.accountList = res.supplier.extras.accountList
                    }
                })
            },
            editEnterprise() {
                this.enterpriseVisible = true
                this.$refs.epe.initInfo(this.supplier.id)
            },
            onFresh() {
                this.router.go(0)
            },
            childOk() {
                this.accountVisible = false
                this.$router.go(0)
            },
            personOk() {
                this.personVisible = false
                this.$router.go(0)
            },
            enterpriseOk() {
                this.enterpriseVisible = false
                this.$router.go(0)
            },
            enterpriseClose() {
                this.enterpriseVisible = false
            },
            personClose() {
                this.personVisible = false
            },
            unitNatureClose() {
              this.unitNatureVisible = false
            },
            childClose() {
                this.accountVisible = false
            },
            addChild() {
                if(this.account.accountType !== '1') {
                    this.$message.info('非管理员,不可操作')
                    return
                }
                this.accountVisible = true
            },
            editPersonInfo() {
                this.personVisible = true
                this.$refs.PersonAccount.initInfo(this.account.id)
            },
            onSelfPersonBillInfo() {
                this.selfPersonBillInfoVisible = true
                this.$refs.selfPersonBillInfo.initInfo()
            },
            delChild(id) {
                let that = this
                this.$http.get("/api/v1/supplier/account/remove_child_account.json?id=" + id).then(function (res) {
                    if (res.code === 200) {
                        that.$router.go(0)
                    }
                })
            },
            onEmail() {
                debugger
                if (this.isEmailEdit === true) {
                    var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/;
                    if (!reg.test(this.account.email)) {
                        this.$message.error("请输入正确的邮箱")
                        return;
                    }
                    let that = this
                    this.$http.get("/api/v1/supplier/account/edit_account_email.json?id=" + that.account.id + "&email=" + that.account.email).then(function (res) {
                        if (res.code === 200) {
                            that.emailEdit = '编辑'
                            that.isEmailEdit = false
                        }
                    })

                }else if (this.isEmailEdit === false){
                    this.emailEdit = '保存'
                    this.isEmailEdit = true
                }
            },
            changeSupplier() {
                if (this.account.supplierId) {
                    this.$message.warn("请解除企业绑定后,再操作，绑定企业请点击企业认证或关联企业!")
                    return;
                }
                if ( this.account.accountType === '1') {
                    this.$message.warn("请移交管理员身份后,再操作");
                    return;
                }
                let that = this
                that.$router.push('/enterprise/EnterpriseAuth')
            },
            delConfirm(id) {
                if (this.account.accountType === '2') {
                    this.$message.warn("非管理员，不可操作!");
                    return;
                }
                let that = this
                this.$confirm({
                    title: '提示',
                    content: '您确定要将该账号从本单位中移除?',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        that.delChild(id)
                    },
                    onCancel() {
                    },
                });
            },
            changePhoneClose() {
                this.changePhoneVisible = false
            },
            changePassClose() {
                this.changePassVisible = false
            },
            onEnterpriseAuth() {
              this.$router.push({path:'/enterprise/CertificationIndex'})
            },
            onNatureAuth() {
                this.$router.push({path:'/enterprise/NatureAuth'})
            },
            onCertificate() {
                this.$router.push({path:'/enterprise/CertificationIndex'})
            },
            onModifyCertificate() {
                this.$router.push({path:'/enterprise/ModifyCertificateIndex'})
            },
            selfPersonBillInfoClose() {
              this.selfPersonBillInfoVisible = false
            },
            payHistoryClose() {
                this.payHistoryVisible = false
            },
            selfBillInfoClose() {
                this.selfBillInfoVisible = false
            },
            payHistory() {
                this.payHistoryVisible = true
                this.$refs.payHistory.initInfo()
            },
            selfBillInfo() {
                // 个体户开票资料
                console.log("this.account.supplierId")
                console.log(this.account.supplierId)
                if (!this.account.supplierId) {
                    this.$message.info("单位未认证不可操作!认证请点击单位认证")
                    return
                }
                this.selfBillInfoVisible = true
                this.$refs.selfBillInfo.initInfo()
            },
            selfPersonBillInfo() {
                // 个人开票资料
            },
            billInfo() {
                //法人开票资料
                if (!this.account.supplierId) {
                    this.$message.info("未绑定企业,不可操作!绑定企业请点击企业认证或关联企业")
                    return
                }
                if (this.account.supplierType === '2' && this.account.accountType === '2') {
                    this.$message.info('非管理员，不可操作')
                    return
                }
              this.billInfoVisible = true;
              this.$refs.billInfo.initInfo()
            },
            unBindClose() {
                this.unBindVisible = false
            },
            changePass() {
                this.changePassVisible = true
                this.$refs.changePass.initInfo(this.account.id)
            },
            changePhone() {
                this.$refs.changePhone.initInfo(this.account.id)
                this.changePhoneVisible = true
            },
            unBind() {
                if (this.account.supplierId){

                    if (this.account.supplierType === '2' && this.account.accountType === '1') {
                        if (this.accountList.length > 1) {
                            this.$message.warn("请移交管理员身份后,再操作");
                            return
                        }else {
                            this.$message.warn("请添加一个个人子账号并移交");
                            return
                        }

                    }
                        this.$refs.unBind.initInfo(this.account.id);
                        this.unBindVisible = true
                }else {
                    this.$message.info("未绑定企业,不可操作!绑定企业请点击企业认证或关联企业。")
                }
            },
            bind() {
                this.$router.push({path:'/enterprise/ConnectSupplier'})
            },
            unitEdit() {
                if (!this.account.supplierId) {
                    this.$message.warn("未绑定企业，不可操作!绑定企业请点击企业认证或关联企业。")
                    return
                }
                if (this.account.accountType !== '1') {
                    this.$message.warn("非管理员,不可操作!")
                    return
                }
                if (!this.supplier.id) {
                    this.$message.warn("企业未认证,不可操作!企业认证请点击企业认证或关联企业。");
                    return;
                }
                // this.$router.push({path:'/enterprise/EnterpriseAuthChange'});
                //ModifyCertificateIndex
                this.$router.push({path:'/enterprise/ModifyCertificateIndex'});
            },
            NatureUnitEdit() {
                if (!this.account.supplierId) {
                    this.$message.warn("企业未认证,不可操作!企业认证请点击企业认证或关联企业。");
                    return;
                }
                // this.$router.push({path:'/enterprise/NatureAuthChange'});
                this.$router.push({path:'/enterprise/ModifyCertificateIndex'});
            },
            moreData() {
                if (!this.account.supplierId) {
                    this.$message.info("未绑定企业，不可操作!企业认证请点击企业认证或关联企业。")
                    return
                }
                this.moreDataVisible = true
            },
            moreDataClose() {
              this.moreDataVisible = false
            },
            onEnterprise() {
                if (!this.account.supplierId) {
                    this.$message.info("未绑定企业，不可操作!企业认证请点击企业认证或关联企业")
                    return
                }
                if (this.supplier.id) {
                    this.$refs.unitInfo.initInfo(this.supplier.id);
                    this.unitInfoVisible = true;
                }else{
                    this.$message.info("企业未认证,不可操作!企业认证请点击企业认证或关联企业");
                }
            },
            onNatureUnit() {
                if (this.supplier.id) {
                    this.$refs.unitNature.initInfo(this.supplier.id);
                    this.unitNatureVisible = true;
                }else{
                    this.$message.info("企业未认证,不可操作!企业认证请点击企业认证或关联企业");
                }
            },
            unitInfoClose() {
                this.unitInfoVisible = false
            },
            billInfoClose() {
                this.billInfoVisible = false
            },
            setConfirm(value) {
                if (this.account.accountType !== '1'){
                    this.$message.warn("非管理员,不可操作!企业认证请点击企业认证或关联企业")
                    return
                }
                let that = this
                this.$confirm({
                    title: '你确定要移交管理员身份吗?',
                    content: '移交后你的管理员身份将移交给该账号',
                onOk(){
                    that.setAdmin(value)
                },
                onCancel(){

                }
            })
            },
            setAdmin(value) {
                let that = this
                this.$http.get('/api/v1/supplier/account/set_admin.json?accountId='+value).then(function (res) {
                    if (res.code === 200) {
                        that.$message.info("管理员设置成功!")
                        that.$router.go(0)
                    }
                });
            }
        },
    };
</script>
<style lang="less" scoped>
    .i-my-info{
        overflow: hidden;width: 100%;height: 225px;position: relative
    }
    .index-bg {
        position: absolute;
        width: 1920px;
        left: 50%;
        margin-left: -960px;
    }
    .main-nav a {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        background: rgba(255, 255, 255, 0.3);
        margin-right: 2px;
    }

    .main-nav a b {
        color: #fff;
        font-weight: 500;
        margin-left: 10px;
    }

    .main-nav a .icon:nth-child(1) {
        display: none;
    }

    .main-nav .active {
        background: #f9f9f9;
    }

    .main-nav .active .icon:nth-child(1) {
        display: block;
    }

    .main-nav .active .icon:nth-child(2) {
        display: none;
    }

    .main-nav .active b {
        color: inherit;
    }

    .main-nav a:hover {
        background: #fff;
    }

    .main-nav a:hover b {
        color: inherit;
    }

    .main-nav a:hover .icon:nth-child(1) {
        display: block;
    }

    .main-nav a:hover .icon:nth-child(2) {
        display: none;
    }

    .icon {
        width: 36px;
        height: 36px;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
        line-height: 30px;
        display: block;
    }

    .handle {
        background: #fff;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        padding: 12px 0;
        z-index: 9;
    }

    .handle .right {
        position: absolute;
        right: 0;
        top: 0;
        height: 32px;
        display: flex;
        align-items: center;
    }

    .handle .right > a:hover {
        color: #2eabff !important;
    }

    .handle .logo {
        display: inline-flex;
        align-items: center;
    }

    .handle .logo img {
        width: 32px;
        height: 32px;
    }

    .handle .logo p {
        font-size: 18px;
        color: #262626;
        margin: 0 0 0 12px;
    }

    .index-info {
        display: flex;
        align-items: center;
        color: #fff;
    }

    .index-info img {
        display: block;
    }

    .index-info p {
        margin: 0;
    }

    /*.shadow{*/
    /*    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);*/
    /*    border-radius: 6px;*/
    /*}*/
    .shadow:hover {
        background: #f1f9ff;
    }

    .my-info {
        color: #262626;
        table-layout: fixed;
    }

    .my-info th {
        padding: 6px 0;
        color: #8c8c8c;
        font-weight: 500;
        text-align: justify;
        text-align-last: justify;
    }
    .my-info td{
        width: 300px;
    }

    .personal {
        font-size: 0;
        margin: 0 -16px;
    }

    .personal .p-col {
        width: 50%;
        padding: 16px;
        display: inline-block;
    }

    .p-card {
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
        overflow: hidden;
        border-radius: 5px;
        position: relative;
    }

    .p-card .p-info {
        font-size: 14px;
        display: inline-block;
        vertical-align: top;
        margin: 10px 20px;
    }
    .p-card .p-info th{
        color: #8c8c8c;
        font-weight: 500;
        text-align: justify;
        text-align-last: justify;
    }

    .p-card .p-info td {
        padding: 6px 0;
    }

    .p-card .p-icon {
        display: inline-block;
        vertical-align: top;
        background: #F6B897;
        color: #fff;
        height: 120px;
        width: 80px;
        line-height: 120px;
        text-align: center;
        font-size: 30px;
    }
    .p-card .p-icon.b{
        background: #7CCE54;
        line-height: 100px;
    }
    .p-card .p-icon.b::after{
        content: "企业管理员";
        position: absolute;
        font-size: 12px;
        bottom: 32px;
        height: 20px;
        line-height: 20px;
        left: 11px;
        z-index: 9;
        color: #fff;
    }

    .p-card .operate {
        font-size: 14px;
        margin-top: 12px;
        position: absolute;
        right: 12px;
        top: 0;
    }
    .p-card .operate button{
        display: block;
        width: 144px;
        text-align: center;
        font-size: 12px;
        height: 28px;
        margin-bottom: 6px;
    }
    .p-card .operate .main{
        background: #E8FFED;
        border: 1px solid #64E32F;
        color: #3EC624;
    }

    .p-card .operate:hover {
        color: rgb(255, 89, 89);
        cursor: pointer;
    }
</style>
